import { Inject, Injectable, Injector }from '@angular/core';

import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
  }

    public Notifications: Notifications_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

